import axiosAuth from '../../axiosMain';
import Vue from 'vue';

async function store(data) {
  let form = new FormData();
  for (let key in data) {
    if (data[key] !== null) form.append(key, data[key]);
  }

  let response = await axiosAuth.post('/consumption/file', form);
  return response.data;
}

async function storeInBucket(file) {
  let form = new FormData();
  for (let key in file) {
    if (file[key] !== null) form.append(key, file[key]);
  }
  let response = await axiosAuth.post('/consumption/file/bucket', form);
  return response.data.data;
}

export default {
  store,
  storeInBucket,
};
